// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullwidth[data-v-4e36d4a0]{width:100%}.halfwidth[data-v-4e36d4a0]{width:50%}.wrapper-relative[data-v-4e36d4a0]{z-index:1;position:relative}.link-relative[data-v-4e36d4a0]{z-index:2;margin-right:75px}.btn-relative[data-v-4e36d4a0],.link-relative[data-v-4e36d4a0]{position:relative;cursor:pointer}.btn-relative[data-v-4e36d4a0]{z-index:3}", ""]);
// Exports
module.exports = exports;
